module.exports = __webpack_public_path__ + "static/media/logo.60f6d19a.png";